import api from '../api/axios';

const invoiceService = {
  getSummary: (month, year, source = 'ECMS') =>
    api.get('/api/admin/invoices/summary', { params: { month, year, source } }),

  getTrend: (months = 6) =>
    api.get('/api/admin/invoices/trend', { params: { months } }),

  getInvoices: (params) =>
    api.get('/api/admin/invoices/list', { params }),

  getInvoice: (invoiceId) =>
    api.get(`/api/admin/invoices/${invoiceId}`),

  updateStatus: (invoiceId, status) =>
    api.patch(`/api/admin/invoices/${invoiceId}/status`, { status }),

  generateInvoice: (data) =>
    api.post('/api/admin/invoices/generate', data),

  bulkGenerate: (invoiceMonth, invoiceYear, source = 'ECMS') =>
    api.post('/api/admin/invoices/bulk/generate', { invoiceMonth, invoiceYear, source }),

  getAllJobs: (source = 'ECMS') =>
    api.get('/api/admin/invoices/bulk/jobs', { params: { source } }),

  getJob: (jobId) =>
    api.get(`/api/admin/invoices/bulk/jobs/${jobId}`),

  getLatestJob: () =>
    api.get('/api/admin/invoices/bulk/jobs/latest'),

  bulkUpdateStatus: (month, year, fromStatus, toStatus) =>
    api.post('/api/admin/invoices/bulk-update-status', null, { params: { month, year, fromStatus, toStatus } }),
};

export default invoiceService;
